import { JobBuildStatus } from "./buildable";

export enum UserStatus {
  Active = "active",
  Blocked = "blocked",
  Pending = "pending",
}

export enum BlockUserStatus {
  Block = "block",
  Active = "active",
}

export enum UserSortField {
  UserStatus = "userstatus",
  Email = "email",
  UsedSpacePercentage = "usedSpacePercentage",
  FileStatus = "filestatus",
  Profile = "profile",
  Devices = "devices",
  Group = "group",
}

export enum UserDataStatus {
  Corrupt = 1,
  Recoverable = 2,
  Safe = 3,
  Recovered = 4,
}

export const userDataStatusToTextMap = {
  [UserDataStatus.Safe]: "Safe",
  [UserDataStatus.Recoverable]: "Recoverable",
  [UserDataStatus.Corrupt]: "Corrupt",
  [UserDataStatus.Recovered]: "Recovered",
};

export interface IUserLoginInfo {
  uid: string;
  name: string;
  email: string;
  organization?: string;
  accountType: AccountType;
  isAdmin?: boolean;
  mfaEnabled?: boolean;
  clusterStatus?: JobBuildStatus;
  externalAccount?: IExternalAccountInfo;
  authenticationMode: AuthenticationMode;
}

export interface IExternalAccountInfo {
  email: string;
  ssoProvider: SSOProvider;
}

export enum AuthenticationMode {
  Local = 1,
  SSOOnly = 2,
  SSOAndLocal = 3,
}

export interface IEntityOwnerInfo extends Pick<IUserLoginInfo, "name" | "email"> {
  id: string;
  isActivated: boolean;
}

export interface IAuthenticationRequest {
  email: string;
  password: string;
  mfaToken?: string;
}

export interface ICreateAccountRequest extends IAuthenticationRequest {
  email: string;
  name: string;
  password: string;
  passwordConfirmation: string;
}

export interface IAccountUpdatePasswordRequest {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;
}

export type ResetPasswordRequest = Pick<IAuthenticationRequest, 'email'>;

export type AccountConfirmationRequest = ResetPasswordRequest & {
  token: string;
}

export type AccountResetPasswordRequest = AccountConfirmationRequest & Pick<ICreateAccountRequest, 'password' | 'passwordConfirmation'>;

export type EnterpriseAccountConfirmationTokenRequest = AccountResetPasswordRequest & Pick<ICreateAccountRequest, 'name'>;

export type EmailResendRequest = ResetPasswordRequest;

export enum AccountType {
  Individual = 1,
  Enterprise = 2
}

export const accountTypeDict = {
  [AccountType.Individual]: "Individual Account",
  [AccountType.Enterprise]: "Enterprise Account"
}

export type ChangeAccountTypeRequest = ResetPasswordRequest & {
  accountType: AccountType;
  organizationName: string;
}

export enum SSOProvider {
  None = 0,
  Microsoft = 1,
}

export const ssoProviderDictionary = {
  [SSOProvider.Microsoft]: "Microsoft"
}

export interface IMfaSetupResponse {
  qrCodeUrl: string;
  secret: string;
}
export interface IEnableMfaRequest {
    token: string;
    secret: string;
}
export interface IEnableMfaResponse {
    recoveryCodes: string[];
}